<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2023-03-20 08:55:51
 * @LastEditors: lc
 * @LastEditTime: 2023-03-21 10:07:10
-->
<template>
  <div class="salesman-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入手机号/姓名查找"></Input>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  filterable
                  placeholder="工作状态...">
            <Option v-for="item in workStatusList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.isauth"
                  clearable
                  filterable
                  placeholder="认证状态...">
            <Option v-for="item in authStatusList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button type="success"
                  @click="showModel()">新增</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!--编辑信息-->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="600"
            :mask-closable="false"
            :styles="styles">
      <Form :model="agents"
            :label-width="60"
            ref="agentsValidate"
            :rules="agentsValidate">
        <FormItem label="姓名"
                  label-position="top"
                  prop="name">
          <Input v-model="agents.name"></Input>
        </FormItem>
        <FormItem label="手机号"
                  label-position="top"
                  prop="phone">
          <Input v-model="agents.phone"></Input>
        </FormItem>
        <FormItem label="头像">
          <upload-thumb v-model="agents.thumb"
                        ref="imagefaceuploadthumb"
                        :defaultList="imagefacethumblist"></upload-thumb>
        </FormItem>
        <!-- <FormItem label="身份证反面照"
                  prop="imageback">
          <upload-thumb v-model="agents.imageback"
                        ref="imagebackuploadthumb"
                        :defaultList="imagebackthumblist"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"></upload-thumb>
        </FormItem> -->
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="editagentinfo('agentsValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>
  
  <script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";

export default {
  name: "salesman-list",
  data () {

    return {
      id: null, // 页面agentid
      loading: true,
      dataloading: true,
      title: "信息",
      isable: false,
      authStatusList: [
        { id: 1, name: "未认证" },
        { id: 2, name: "已认证" }
      ],
      workStatusList: [
        { id: 1, name: "正常" },
        { id: 2, name: "禁用" }
      ],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      agents: {},
      imagefacethumblist: [], // 身份证是正面
      imagebackthumblist: [], // 身份证反面
      thumblist: [], // 营业执照
      isClear: false,
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      list: [
        {
          title: "用户ID",
          key: "uuid",
          width: 150
        },
        {
          title: "电话",
          key: "phone",
          width: 120,
        },
        {
          title: "姓名",
          key: "name",
          width: 200,
        },
        {
          title: "认证",
          key: "isauth",
          width: 200,
        },
        {
          title: "工作状态",
          key: "status",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status // 控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 350,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px",
                    display: params.row.isauth == "未认证" ? "none" : "inline - block"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.saomalog(params.row.uuid);
                    }
                  }
                },
                "扫码记录"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              ),
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false,
      agentsValidate: {
        name: [{ required: true, message: "姓名必须填写", trigger: "blur" }],
        phone: [{ required: true, message: "手机号必须填写", trigger: "blur" }],
        // imageface: [
        //   { required: true, message: "请上传身份证正面", trigger: "change" }
        // ],
        // imageback: [
        //   { required: true, message: "请上传身份证反面", trigger: "change" }
        // ],
      },
      showModalStatus3: false,
      showModalStatus: false
    };
  },
  created: function () {
    this.id = this.$route.params.id;
    this.getTableList();
  },
  components: {
    UploadThumb,
    uploadthumbTwo
  },
  watch: {
    "$route.params.id": function (curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function () {
      this.$api.salesman
        .list({
          page: this.pages.page,
          size: this.pages.size,
          id: this.id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.salesman.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        } else {
          this.getTableList();
        }
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        status: this.formItem.status,
        isauth: this.formItem.isauth,
        page: this.pages.page,
        size: this.pages.size,
        id: this.id
      };
      this.$api.salesman.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    showModel () {
      this.agents = {
        id: null,
        name: "",
        phone: ""
      };
      this.imagefacethumblist = [];
      this.showModalStatus = true;
    },
    // 扫码记录
    saomalog (id) {
      this.$router.push("/salesmansaoma/list/" + id);
    },
    // 代理商详情
    detail (index) {
      this.agents = {
        id: null,
        name: "",
        phone: ""
      };
      this.imagefacethumblist = [];
      this.imagebackthumblist = [];

      this.$refs["agentsValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
      this.agents.id = index;
      this.$api.salesman.detail({ id: index }).then(res => {
        this.agents.name = res.result.name;
        this.agents.status = res.result.status;
        this.agents.phone = res.result.phone;
        if (res.result.thumb != null) {
          this.imagefacethumblist.push({
            name: res.result.thumb,
            url: res.result.thumb,
            status: "finished"
          });
        }
      });
    },
    // 修改代理商信息
    editagentinfo (name) {
      if (this.$refs["imagefaceuploadthumb"].uploadList.length > 0) {
        this.agents.thumb = this.$refs[
          "imagefaceuploadthumb"
        ].uploadList[0].url;
      } else {
        this.agents.thumb = "";
      }
      //   if (this.$refs["imagebackuploadthumb"].uploadList.length > 0) {
      //     this.agents.imageback = this.$refs[
      //       "imagebackuploadthumb"
      //     ].uploadList[0].url;
      //   } else {
      //     this.agents.imageback = "";
      //   }
      this.$refs[name].validate(valid => {
        if (valid) {
          let params = {};
          params.id = this.agents.id; //是	string	代理商户UUID
          params.name = this.agents.name; //否	string	姓名
          params.first_agent_uuid = this.id;
          params.phone = this.agents.phone;
          params.thumb = this.agents.thumb;
          if (params.id == null || params.id == 0) {
            this.$api.salesman.create(params).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.salesman.edit(params).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          }

        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    remove: function (index) {
      this.$api.salesman
        .isremove({
          id: index
        })
        .then(res => {
          if (res.code == 200) {
            this.$api.salesman
              .remove({
                id: index
              })
              .then(res => {
                if (res.code == 200) {
                  this.getTableList();
                }
              });
          } else {
            this.$Modal.confirm({
              title: "警告",
              content: res.msg,
              onOk: () => {
                this.$api.salesman
                  .remove({
                    id: index
                  })
                  .then(res => {
                    if (res.code == 200) {
                      this.getTableList();
                    }
                  });
              }
            });
          }
        });
    },
  }
};
  </script>
  
  <style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
  
